import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import locale from 'antd/lib/locale/zh_CN';
import store from 'modules/store';
import App from 'layouts/index';

import './styles/index.less';

const renderApp = () => {
  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <ConfigProvider locale={locale}>
          <App />
        </ConfigProvider>
      </BrowserRouter>
    </Provider>,
    document.getElementById('root'),
  );
};

const bootstrapApp = async () => {
  renderApp();
};

bootstrapApp();
